'use strict';

var _classCallCheck = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var Decoder = require('./decoder');

var utils = require('./utils');
/**
 * Output the diagnostic format from a stream of CBOR bytes.
 *
 */


var Diagnose =
/*#__PURE__*/
function (_Decoder) {
  _inherits(Diagnose, _Decoder);

  function Diagnose() {
    _classCallCheck(this, Diagnose);

    return _possibleConstructorReturn(this, _getPrototypeOf(Diagnose).apply(this, arguments));
  }

  _createClass(Diagnose, [{
    key: "createTag",
    value: function createTag(tagNumber, value) {
      return "".concat(tagNumber, "(").concat(value, ")");
    }
  }, {
    key: "createInt",
    value: function createInt(val) {
      return _get(_getPrototypeOf(Diagnose.prototype), "createInt", this).call(this, val).toString();
    }
  }, {
    key: "createInt32",
    value: function createInt32(f, g) {
      return _get(_getPrototypeOf(Diagnose.prototype), "createInt32", this).call(this, f, g).toString();
    }
  }, {
    key: "createInt64",
    value: function createInt64(f1, f2, g1, g2) {
      return _get(_getPrototypeOf(Diagnose.prototype), "createInt64", this).call(this, f1, f2, g1, g2).toString();
    }
  }, {
    key: "createInt32Neg",
    value: function createInt32Neg(f, g) {
      return _get(_getPrototypeOf(Diagnose.prototype), "createInt32Neg", this).call(this, f, g).toString();
    }
  }, {
    key: "createInt64Neg",
    value: function createInt64Neg(f1, f2, g1, g2) {
      return _get(_getPrototypeOf(Diagnose.prototype), "createInt64Neg", this).call(this, f1, f2, g1, g2).toString();
    }
  }, {
    key: "createTrue",
    value: function createTrue() {
      return 'true';
    }
  }, {
    key: "createFalse",
    value: function createFalse() {
      return 'false';
    }
  }, {
    key: "createFloat",
    value: function createFloat(val) {
      var fl = _get(_getPrototypeOf(Diagnose.prototype), "createFloat", this).call(this, val);

      if (utils.isNegativeZero(val)) {
        return '-0_1';
      }

      return "".concat(fl, "_1");
    }
  }, {
    key: "createFloatSingle",
    value: function createFloatSingle(a, b, c, d) {
      var fl = _get(_getPrototypeOf(Diagnose.prototype), "createFloatSingle", this).call(this, a, b, c, d);

      return "".concat(fl, "_2");
    }
  }, {
    key: "createFloatDouble",
    value: function createFloatDouble(a, b, c, d, e, f, g, h) {
      var fl = _get(_getPrototypeOf(Diagnose.prototype), "createFloatDouble", this).call(this, a, b, c, d, e, f, g, h);

      return "".concat(fl, "_3");
    }
  }, {
    key: "createByteString",
    value: function createByteString(raw, len) {
      var val = raw.join(', ');

      if (len === -1) {
        return "(_ ".concat(val, ")");
      }

      return "h'".concat(val);
    }
  }, {
    key: "createByteStringFromHeap",
    value: function createByteStringFromHeap(start, end) {
      var val = Buffer.from(_get(_getPrototypeOf(Diagnose.prototype), "createByteStringFromHeap", this).call(this, start, end)).toString('hex');
      return "h'".concat(val, "'");
    }
  }, {
    key: "createInfinity",
    value: function createInfinity() {
      return 'Infinity_1';
    }
  }, {
    key: "createInfinityNeg",
    value: function createInfinityNeg() {
      return '-Infinity_1';
    }
  }, {
    key: "createNaN",
    value: function createNaN() {
      return 'NaN_1';
    }
  }, {
    key: "createNaNNeg",
    value: function createNaNNeg() {
      return '-NaN_1';
    }
  }, {
    key: "createNull",
    value: function createNull() {
      return 'null';
    }
  }, {
    key: "createUndefined",
    value: function createUndefined() {
      return 'undefined';
    }
  }, {
    key: "createSimpleUnassigned",
    value: function createSimpleUnassigned(val) {
      return "simple(".concat(val, ")");
    }
  }, {
    key: "createArray",
    value: function createArray(arr, len) {
      var val = _get(_getPrototypeOf(Diagnose.prototype), "createArray", this).call(this, arr, len);

      if (len === -1) {
        // indefinite
        return "[_ ".concat(val.join(', '), "]");
      }

      return "[".concat(val.join(', '), "]");
    }
  }, {
    key: "createMap",
    value: function createMap(map, len) {
      var val = _get(_getPrototypeOf(Diagnose.prototype), "createMap", this).call(this, map);

      var list = Array.from(val.keys()).reduce(collectObject(val), '');

      if (len === -1) {
        return "{_ ".concat(list, "}");
      }

      return "{".concat(list, "}");
    }
  }, {
    key: "createObject",
    value: function createObject(obj, len) {
      var val = _get(_getPrototypeOf(Diagnose.prototype), "createObject", this).call(this, obj);

      var map = Object.keys(val).reduce(collectObject(val), '');

      if (len === -1) {
        return "{_ ".concat(map, "}");
      }

      return "{".concat(map, "}");
    }
  }, {
    key: "createUtf8String",
    value: function createUtf8String(raw, len) {
      var val = raw.join(', ');

      if (len === -1) {
        return "(_ ".concat(val, ")");
      }

      return "\"".concat(val, "\"");
    }
  }, {
    key: "createUtf8StringFromHeap",
    value: function createUtf8StringFromHeap(start, end) {
      var val = Buffer.from(_get(_getPrototypeOf(Diagnose.prototype), "createUtf8StringFromHeap", this).call(this, start, end)).toString('utf8');
      return "\"".concat(val, "\"");
    }
  }], [{
    key: "diagnose",
    value: function diagnose(input, enc) {
      if (typeof input === 'string') {
        input = Buffer.from(input, enc || 'hex');
      }

      var dec = new Diagnose();
      return dec.decodeFirst(input);
    }
  }]);

  return Diagnose;
}(Decoder);

module.exports = Diagnose;

function collectObject(val) {
  return function (acc, key) {
    if (acc) {
      return "".concat(acc, ", ").concat(key, ": ").concat(val[key]);
    }

    return "".concat(key, ": ").concat(val[key]);
  };
}